"use strict";
// TODO: other channel properties mentioned in project.js:
// level, frozen, hidden, thumbnailUrl, migratedToS3, sharedWith, libraryName, libraryDescription,
// latestLibraryVersion, publishLibrary, libraryPublishedAt
//
// Do we still want/need these? Should they be on a separate type?
// If the ChannelsApi on the server doesn't care about these, they should
// live elsewhere.
// The library data should definitely live elsewhere.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectManagerStorageType = void 0;
var ProjectManagerStorageType;
(function (ProjectManagerStorageType) {
    ProjectManagerStorageType["LOCAL"] = "LOCAL";
    ProjectManagerStorageType["REMOTE"] = "REMOTE";
})(ProjectManagerStorageType || (exports.ProjectManagerStorageType = ProjectManagerStorageType = {}));
